import { useParams } from "react-router-dom";
import { approvalTabsConfig } from "../config";
import { Nullable } from "@/services/api/request";

export const useInboxTabs = (totalCount?: Nullable<number>) => {
  const { tab } = useParams();

  return approvalTabsConfig.map(item => {
    const count: string = totalCount ? `(${totalCount})` : "";

    const label = tab === item.id ? `${item.label} ${count}` : item.label;

    return {
      ...item,
      label,
    };
  });
};
